// Inside draft-convert this is used to convert draft contentState (required param) to raw serialized state.
// We already have raw state (as returned from the API), so we'd like to pass that right to draft-convert
// so we make that line a noop by forcing it to use this module instead of the real draft-js one.
export const convertToRaw = function(contentState) {
  // We need to deep-copy the contentState because draft-convert does some
  // mutation of the object returned by this function. I have a PR:
  // https://github.com/HubSpot/draft-convert/pull/128
  return JSON.parse(JSON.stringify(contentState));
};
